import React from 'react'

import useInitLoggedInData from '@src/hooks/auth/initLoggedInData/useInitLoggedInData'

import VersionChecker from '@src/components/version/VersionChecker'

export type PropsType = {
	children: React.ReactNode
}

const AppWrapper = ({ children }: PropsType) => {
	useInitLoggedInData()

	return (
		<>
			<VersionChecker />
			{children}
		</>
	)
}

export default AppWrapper
